import React from 'react';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import { useTranslation } from 'react-i18next';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import { icons } from '../../../../../shared/icons';

const GridProvider = ({ data, handleOpenDeleteDialog, handleEditData }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Options',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },

    { field: 'oznaka', headerName: t('name'), width: 300 },
    { field: 'nazivTipaMasine', headerName: t('machineType'), width: 300 },
    { field: 'nazivKategorije', headerName: t('category'), width: 300 },
    { field: 'metadata', headerName: 'Metadata', width: 300 },
    { field: 'opis', headerName: t('description'), width: 300 },
  ];
  return (
    <div style={{ height: '75vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} />
    </div>
  );
};

export default GridProvider;
